import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
  @Input() showContent = true;
  returnUrl!: string;
  constructor( 
    private route: ActivatedRoute, private router: Router
  ) {
    
  }
  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }
  async goToLogin() {
    return this.router.navigate(['/login']);
  }
  async goBack() {
    this.router.navigateByUrl(this.returnUrl);
  }

  
  
}
